import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import AppName from 'src/components/AppName/AppName'
import Box from 'src/components/Box/Box'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import TopLevelError from 'src/components/TopLevelError/TopLevelError'
import { useBackgroundDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import { postResetPassword } from 'src/redux/actions/auth.actions'
import { css } from 'styled-components'

interface UpdatePasswordBoxProps {
  className?: string
  emailSending: boolean
  topLevelError?: string
  user?: UserListModel
}

const UpdatePasswordBox: React.FC<UpdatePasswordBoxProps> = (
  props,
): React.ReactElement => {
  const dispatch = useBackgroundDispatch()

  const dispatchResetPassword = (): void => {
    if (props.user !== undefined) {
      dispatch(postResetPassword(props.user.email, true))
    }
  }

  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
        padding-bottom: 40px;
      `}
    >
      <span
        css={css`
          ${getFontCss(
            20,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Update Password'} />
      </span>
      <div
        css={css`
          margin-top: 36px;
        `}
      >
        <p>
          <Trns
            source={
              'We will send instructions to the email address associated with your ${appName} profile.'
            }
            expressions={{
              appName: <AppName />,
            }}
          />
        </p>
        <Button
          big
          css={css`
            margin-top: 36px;
          `}
          design={ButtonDesigns.designCta}
          loadingText={<Trns source={'Sending'} />}
          text={<Trns source={'Send Update Instructions'} />}
          type={ButtonTypes.button}
          loading={props.emailSending}
          disabled={props.emailSending}
          onClick={dispatchResetPassword}
        />
        {props.topLevelError !== undefined && (
          <TopLevelError error={props.topLevelError} />
        )}
      </div>
    </Box>
  )
}

export default UpdatePasswordBox
